<template>
	<b-modal
		v-model="showDelete"
		id="deletemodal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
	>
		<main class="p-4 d-flex">
			<section class="mr-3">
				<img
					v-if="id === 'pricing'"
					src="../../assets/common/warningIcon.svg"
					alt=""
				/>
				<img v-else src="@/assets/common/delete-modal-icon.svg" alt="" />
			</section>
			<section class="flex-grow-1">
				<div class="d-flex justify-content-between">
					<h1 class="black-txt">{{ headtext }}</h1>
					<img
						@click="closeModal"
						class="rotate-on-hover"
						src="@/assets/common/blue-cross.svg"
						alt=""
					/>
				</div>
				<h4
					class="dark-black-txt font-weight-400 mt-2"
					v-html="summarytext"
				></h4>
			</section>
		</main>
		<footer class="d-flex align-items-center justify-content-end pr-3 pb-3">
			<OButton text="Cancel" class="mr-3 p1-15" @clicked="closeModal" />
			<PButton
				widthClass="button-width"
				:loading="loading"
				:text="id === 'pricing' ? 'Continue' : 'Delete'"
				@clicked="action"
				class="p1-15"
			/>
		</footer>
	</b-modal>
</template>

<script>
export default {
	props: {
		showDelete: {
			type: Boolean,
			default: false,
		},
		headtext: {
			type: String,
			default: "",
		},
		summarytext: {
			type: String,
			default: "",
		},
		loading: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			default: "",
		},
	},
	methods: {
		action() {
			if (!this.loading) {
				this.$emit("handle-delete");
			}
		},
		closeModal() {
			if (!this.loading) {
				this.$emit("closeModal", "showDelete");
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
